import { render, staticRenderFns, recyclableRender, components } from "./LogoMsg.vue?vue&type=template&id=7be86bc4&scoped=true&"
var renderjs
import script from "./LogoMsg.vue?vue&type=script&lang=js&"
export * from "./LogoMsg.vue?vue&type=script&lang=js&"
import style0 from "./LogoMsg.vue?vue&type=style&index=0&id=7be86bc4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7be86bc4",
  null,
  false,
  components,
  renderjs
)

export default component.exports